module.exports = "/images/vendor/flag-icon-css/flags/1x1/gh.svg?77872d15b6a675d391e8355c98f9c020";